/**
 * Thank You Page & Contact Form Submission Logic
 */

(function () {
  'use strict';

  function initThankYouView() {
    var search = window.location.search || '';
    var hash = window.location.hash || '';
    var path = window.location.pathname || '';

    // 0. Do NOT show thank-you view or update URL while user is solving captcha challenge
    if (path.indexOf('/challenge') !== -1 || path.indexOf('/captcha') !== -1) {
      return;
    }

    var isPosted =
      search.indexOf('contact_posted=true') !== -1 ||
      hash.indexOf('contact_posted=true') !== -1 ||
      sessionStorage.getItem('contact_posted') === 'true';

    var formSource = sessionStorage.getItem('submitted_form_source') || '';

    // Helper: map from= param to display title and URL
    function getSourceInfo(fromParam) {
      var map = {
        'blog':       { title: 'Blog',       url: '/blogs/our-latest-blogs' },
        'home':       { title: 'Home',       url: '/' },
        'product':    { title: 'Product',    url: '/collections/all' },
        'collection': { title: 'Collection', url: '/collections' },
        'contact-us': { title: 'Contact us', url: '/pages/contact-us' },
        'contact':    { title: 'Contact us', url: '/pages/contact-us' },
        'about-us':   { title: 'About us',   url: '/pages/about-us' },
        'faq':        { title: 'FAQ',        url: '/pages/faq' },
        'sticky':     { title: 'Contact us', url: '/pages/contact-us' }
      };
      return map[fromParam] || { title: 'Contact us', url: '/pages/contact-us' };
    }

    // 1. Setup Standalone Thank You Page (/pages/thank-you):
    if (path.indexOf('/pages/thank-you') !== -1) {
      // Parse the from= parameter
      var fromMatch = search.match(/from=([^&#]+)/);
      var fromParam = fromMatch ? fromMatch[1] : '';

      // Also check sessionStorage for source
      if (!fromParam && formSource === 'blog-page') fromParam = 'blog';
      if (!fromParam && formSource === 'side-button') fromParam = 'contact-us';
      if (!fromParam && formSource === 'contact-us-page') fromParam = 'contact-us';
      if (!fromParam) fromParam = 'contact-us';

      var sourceInfo = getSourceInfo(fromParam);
      var breadcrumbTitle = sourceInfo.title;

      // If a title query param is present (e.g. from=product&title=product-handle), use it for breadcrumb
      var titleMatch = search.match(/title=([^&#]+)/);
      if (fromParam === 'product' && titleMatch) {
        try {
          var decodedTitle = decodeURIComponent(titleMatch[1]);
          var prettyTitle = decodedTitle.replace(/-/g, ' ').replace(/\b\w/g, function (l) { return l.toUpperCase(); });
          breadcrumbTitle = prettyTitle;
          sourceInfo.url = '/products/' + decodedTitle;
          // Use a short, generic H1 for product inquiries
          sourceInfo.title = 'Product';
        } catch (e) {
          // ignore decode errors and fall back to default
        }
      }

      // Update breadcrumb
      var tyBreadcrumb =
        document.getElementById('thank-you-breadcrumb-link') ||
        document.querySelector('.breadcrumbs .breadcrumb__link[aria-current="page"]');

      if (tyBreadcrumb) {
        tyBreadcrumb.textContent = breadcrumbTitle;
        tyBreadcrumb.setAttribute('href', sourceInfo.url);
      }

      // Update H1 source header
      var sourceHeader = document.getElementById('thank-you-source-header');
      if (sourceHeader) {
        sourceHeader.textContent = sourceInfo.title;
      }

      setTimeout(fireThankYouConfetti, 200);
      sessionStorage.removeItem('contact_posted');
      sessionStorage.removeItem('submitted_form_source');
      return;
    }

    // 2. Redirect to /pages/thank-you if posted on any other page
    if (isPosted) {
      var redirectFrom = 'contact-us';
      if (formSource === 'side-button' || hash.indexOf('ContactUsCard') !== -1 || search.indexOf('ContactUsCard') !== -1) {
        // Detect source page from current URL
        if (path === '/' || path === '') {
          redirectFrom = 'home';
        } else if (path.indexOf('/products/') !== -1) {
          redirectFrom = 'product';
        } else if (path.indexOf('/collections') !== -1) {
          redirectFrom = 'collection';
        } else if (path.indexOf('/blogs/') !== -1) {
          redirectFrom = 'blog';
        } else if (path.indexOf('/pages/contact-us') !== -1) {
          redirectFrom = 'contact-us';
        } else if (path.indexOf('/pages/about') !== -1) {
          redirectFrom = 'about-us';
        } else if (path.indexOf('/pages/faq') !== -1) {
          redirectFrom = 'faq';
        }
      } else if (formSource === 'blog-page' || path.indexOf('/blogs') !== -1 || hash.indexOf('ContactFormSidebar') !== -1) {
        redirectFrom = 'blog';
      }

      window.location.href = '/pages/thank-you?from=' + redirectFrom;
      return;
    }

    // Store session flags when ANY contact form send button is submitted
    document.querySelectorAll('form[action*="/contact"]').forEach(function (form) {
      form.addEventListener('submit', function () {
        sessionStorage.setItem('contact_posted', 'true');

        if (form.id === 'ContactUsCardContactForm' || form.classList.contains('contact-us-card-form')) {
          sessionStorage.setItem('submitted_form_source', 'side-button');
        } else if (form.id === 'ContactFormSidebar' || form.classList.contains('sidebar-contact-form')) {
          sessionStorage.setItem('submitted_form_source', 'blog-page');
        } else {
          sessionStorage.setItem('submitted_form_source', 'contact-us-page');
        }
      });
    });
  }

  // Celebration Confetti Crackers Canvas Animation
  function fireThankYouConfetti() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var canvas =
      document.getElementById('contact-thank-you-confetti-canvas') ||
      document.querySelector('.thank-you-confetti-canvas');
    if (!canvas) return;

    var ctx = canvas.getContext('2d');
    var width = (canvas.width = canvas.offsetWidth || window.innerWidth);
    var height = (canvas.height = canvas.offsetHeight || 500);

    var colors = ['#e31c1c', '#ffab68', '#1c70be', '#21f996', '#ffffff', '#ffd700'];
    var particles = [];
    var particleCount = 55;

    for (var i = 0; i < particleCount; i++) {
      particles.push({
        x: width / 2,
        y: height / 3,
        vx: (Math.random() - 0.5) * 14,
        vy: (Math.random() - 0.7) * 14,
        size: Math.random() * 8 + 4,
        color: colors[Math.floor(Math.random() * colors.length)],
        rotation: Math.random() * 360,
        vRot: (Math.random() - 0.5) * 12,
        opacity: 1,
      });
    }

    var frameCount = 0;

    function render() {
      ctx.clearRect(0, 0, width, height);
      var activeParticles = 0;

      particles.forEach(function (p) {
        if (p.opacity <= 0) return;
        activeParticles++;
        p.x += p.vx;
        p.y += p.vy;
        p.vy += 0.25;
        p.rotation += p.vRot;
        p.opacity -= 0.01;

        ctx.save();
        ctx.globalAlpha = Math.max(p.opacity, 0);
        ctx.translate(p.x, p.y);
        ctx.rotate((p.rotation * Math.PI) / 180);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size);
        ctx.restore();
      });

      if (activeParticles > 0 && frameCount < 200) {
        frameCount++;
        requestAnimationFrame(render);
      } else {
        ctx.clearRect(0, 0, width, height);
      }
    }

    setTimeout(render, 100);
  }

  window.fireThankYouConfetti = fireThankYouConfetti;

  // Run initialization on DOM load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initThankYouView);
  } else {
    initThankYouView();
  }
})();
